const SET_PROVINCES = (state, provinces) => {
  state.provinces = provinces;
};
const SET_DISTRICTS = (state, districts) => {
  state.districts = districts;
};
const SET_COMMUNES = (state, communes) => {
  state.communes = communes;
};
const SET_LUAT_PAKN = (state, danhSachLuatPAKN) => {
  state.danhSachLuatPAKN = danhSachLuatPAKN;
};
const SET_NGUON_PAKN = (state, danhSachNguonPAKN) => {
  state.danhSachNguonPAKN = danhSachNguonPAKN;
};
const SET_NOI_DUNG_PAKN = (state, danhSachNoiDungPAKN) => {
  state.danhSachNoiDungPAKN = danhSachNoiDungPAKN;
};
const SET_LINH_VUC_PAKN = (state, danhSachLinhVucPAKN) => {
  state.danhSachLinhVucPAKN = danhSachLinhVucPAKN;
};

export default {
  SET_PROVINCES,
  SET_DISTRICTS,
  SET_COMMUNES,
  SET_LUAT_PAKN,
  SET_NGUON_PAKN,
  SET_NOI_DUNG_PAKN,
  SET_LINH_VUC_PAKN
};
